import * as MFRuntime from '@module-federation/enhanced/runtime'
import * as MFSDK from '@module-federation/sdk'
import {shareGlobalName} from 'src/helper/config'
window[shareGlobalName] = {
  MFRuntime,
  MFSDK,
}
export {MFRuntime, MFSDK}
